<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 17.438 17.438"
  >
    <path
      id="Icon_awesome-check-circle"
      data-name="Icon awesome-check-circle"
      d="M17.719,9A8.719,8.719,0,1,1,9,.281,8.719,8.719,0,0,1,17.719,9ZM7.992,13.617,14.46,7.148a.563.563,0,0,0,0-.8l-.8-.8a.562.562,0,0,0-.8,0L7.594,10.832,5.131,8.369a.563.563,0,0,0-.8,0l-.8.8a.563.563,0,0,0,0,.8L7.2,13.616a.563.563,0,0,0,.8,0Z"
      transform="translate(-0.281 -0.281)"
      fill="#f0324c"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-5 -mt-2'
    },
    height: {
      type: String,
      default: 'h-5'
    }
  }
}
</script>
